import React from 'react';
import { useTranslation } from 'react-i18next';
import './Loading.css';

const Loading = ({ 
  size = 'medium', 
  message = null, 
  overlay = false, 
  type = 'spinner',
  color = 'primary',
  fullScreen = false 
}) => {
  const { t } = useTranslation();

  const getLoadingMessage = () => {
    if (message) return message;
    return t('common.loading', 'Loading...');
  };

  const getSizeClass = () => {
    switch (size) {
      case 'small': return 'loading-small';
      case 'large': return 'loading-large';
      case 'xlarge': return 'loading-xlarge';
      default: return 'loading-medium';
    }
  };

  const getColorClass = () => {
    switch (color) {
      case 'secondary': return 'loading-secondary';
      case 'success': return 'loading-success';
      case 'warning': return 'loading-warning';
      case 'error': return 'loading-error';
      case 'white': return 'loading-white';
      default: return 'loading-primary';
    }
  };

  const renderSpinner = () => (
    <div className={`common-loading-spinner ${getSizeClass()} ${getColorClass()}`}>
      <div className="spinner-circle"></div>
      <div className="spinner-circle spinner-circle-2"></div>
      <div className="spinner-circle spinner-circle-3"></div>
    </div>
  );

  const renderDots = () => (
    <div className={`loading-dots ${getSizeClass()} ${getColorClass()}`}>
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
    </div>
  );

  const renderPulse = () => (
    <div className={`loading-pulse ${getSizeClass()} ${getColorClass()}`}>
      <div className="pulse-circle"></div>
    </div>
  );

  const renderBars = () => (
    <div className={`loading-bars ${getSizeClass()} ${getColorClass()}`}>
      <div className="bar"></div>
      <div className="bar"></div>
      <div className="bar"></div>
      <div className="bar"></div>
      <div className="bar"></div>
    </div>
  );

  const renderLoader = () => {
    switch (type) {
      case 'dots': return renderDots();
      case 'pulse': return renderPulse();
      case 'bars': return renderBars();
      default: return renderSpinner();
    }
  };

  const loadingContent = (
    <div className="loading-content">
      {renderLoader()}
      {message !== false && (
        <div className="loading-message">
          {getLoadingMessage()}
        </div>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="loading-fullscreen">
        <div className="loading-fullscreen-content">
          {loadingContent}
        </div>
      </div>
    );
  }

  if (overlay) {
    return (
      <div className="loading-overlay">
        <div className="loading-overlay-content">
          {loadingContent}
        </div>
      </div>
    );
  }

  return (
    <div className="loading-container">
      {loadingContent}
    </div>
  );
};

export default Loading;
